import React from "react";
import PlayerModal from "../modals/PlayerModal";
import { useChartingSession } from "./hooks/useChartingSession";
import { BullpenChartSection } from "./view/BullpenChartSection";
import { GameChartSection } from "./view/GameChartSection";

export const ChartingView = ({ chart, onSave, onBack }) => {
  const {
    isBullpen,
    zoneType,
    isLoading,
    isPlayerModalOpen,
    editingPlayer,
    pitcher,
    batter,
    catcher,
    umpire,
    pitches,
    currentPitch,
    currentHit,
    shouldResetPlot,
    isPitcherView,
    isStrikeZone,
    setIsPlayerModalOpen,
    setCurrentPitch,
    setCurrentHit,
    setIsPitcherView,
    setIsStrikeZone,
    handlePlayerEdit,
    handlePlayerSubmit,
    handlePlotPitch,
    handleAddPitch,
    handleResetPitch,
    handleDeletePitch,
    handleUpdatePitch,
  } = useChartingSession({ chart, onSave });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="w-12 h-12 border-4 border-blue-600 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden">
      <div className="container max-w-full lg:max-w-[1200px] mx-auto px-2 sm:px-6 lg:px-8 py-4 sm:py-8 relative z-10">
        {isBullpen ? (
          <BullpenChartSection
            onBack={onBack}
            pitcher={pitcher}
            pitches={pitches}
            currentPitch={currentPitch}
            shouldResetPlot={shouldResetPlot}
            isPitcherView={isPitcherView}
            zoneType={zoneType}
            onPlayerEdit={handlePlayerEdit}
            onPitchChange={setCurrentPitch}
            onSubmitPitch={handleAddPitch}
            onResetPitch={handleResetPitch}
            onToggleView={() => setIsPitcherView((prev) => !prev)}
            onPlotPitch={handlePlotPitch}
            onDeletePitch={handleDeletePitch}
            onUpdatePitch={handleUpdatePitch}
          />
        ) : (
          <GameChartSection
            onBack={onBack}
            pitcher={pitcher}
            batter={batter}
            catcher={catcher}
            umpire={umpire}
            pitches={pitches}
            currentPitch={currentPitch}
            currentHit={currentHit}
            shouldResetPlot={shouldResetPlot}
            isPitcherView={isPitcherView}
            isStrikeZone={isStrikeZone}
            isBullpen={isBullpen}
            zoneType={zoneType}
            onPlayerEdit={handlePlayerEdit}
            onPitchChange={setCurrentPitch}
            onHitChange={setCurrentHit}
            onSubmitPitch={handleAddPitch}
            onResetPitch={handleResetPitch}
            onToggleView={() => setIsPitcherView((prev) => !prev)}
            onSetStrikeZoneView={setIsStrikeZone}
            onPlotPitch={handlePlotPitch}
            onDeletePitch={handleDeletePitch}
            onUpdatePitch={handleUpdatePitch}
          />
        )}
      </div>

      <PlayerModal
        isOpen={isPlayerModalOpen}
        onClose={() => setIsPlayerModalOpen(false)}
        onSubmit={handlePlayerSubmit}
        type={editingPlayer}
        chart={chart}
      />
    </div>
  );
};